import { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import { IntroContext } from './Components/IntroContext';
import Header from './Components/Header';
import Main from './Components/Main';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Wwork from './Components/wwork';
import Abt from './Components/abt'
import Contas from './Components/contas'
import './App.css';
import './Components/mediaMobile.css'
import Loader from './Components/Loader';
import Prj1 from './Components/prj1';
import Prj2 from './Components/prj2';
import Endview from './Components/endview';
import Photoextr from './Components/photoextr';
import Medchat from './Components/medchat';
import Fblur from './Components/fblur';
import RouteMeta from './Components/RouteMeta';
import ScrollToTop from './Components/scrollToTop';
import SimpleCursor from './Components/SimpleCursor';


function App() {
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  // Intro only runs on a fresh load of the homepage — deep links (e.g. a
  // shared case study) shouldn't sit behind a curtain.
  const [loading, setLoading] = useState(
    () => typeof window !== 'undefined' && window.location.pathname === '/'
  );

  // Hold the page still while the curtain is down.
  useEffect(() => {
    document.body.style.overflow = loading ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [loading]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < lastScrollY) {
        setShowHeader(true);  // scrolling up
      } else {
        setShowHeader(false); // scrolling down
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <Router>
      <ScrollToTop />
      <RouteMeta />

      {/* Intro curtain sits on top of the already-rendered page, then lifts. */}
      <AnimatePresence>
        {loading && <Loader key="intro" onDone={() => setLoading(false)} />}
      </AnimatePresence>

    <IntroContext.Provider value={!loading}>
    <div className="App">
      <SimpleCursor />
      <div className={`headerWrapper ${showHeader ? "show" : "hide"}`}>
        <Header />
      </div>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/wwork" element={<Wwork />} />
        <Route path="/about" element={<Abt />} />
        <Route path="/contact" element={<Contas />} />
        <Route path='/prj1' element={<Prj1 />} />
        <Route path='/prj2' element={<Prj2 />} />
        <Route path='/endview' element={<Endview />} />
        <Route path='/photoextr' element={<Photoextr />} />
        <Route path='/medchat' element={<Medchat />} />
        <Route path='/fblur' element={<Fblur />} />
      </Routes>
    </div>
    </IntroContext.Provider>
    </Router>
  );
}

export default App;
